import CbcMarketingPage from './CbcMarketingPage';
export default function PublicWelcomeScreen({onLogin}:{onLogin:()=>void}) {
 return <CbcMarketingPage pageKey="home" onLogin={onLogin}/>;
}
